const songs = [
  { id: "song1", name: "1 - Amanecer - Edurne" },
  { id: "song2", name: "2 - La La Love - Ivi Adamou" },
  { id: "song3", name: "3 - Para Llenarme De Ti - Ramón" },
  { id: "song4", name: "4 - Dime - Beth" },
  { id: "song5", name: "5 - Amar Pelos Dois - Salvador S." },
  { id: "song6", name: "6 - Bandido - Azucar Moreno" },
  { id: "song7", name: "7 - Zitti E Buoni - Maneskin" },
  { id: "song8", name: "8 - Waterloo - ABBA" },
  { id: "song9", name: "9 - Dile Que La Quiero - David Civera" },
  { id: "song10", name: "10 - Voila - Barbara Pravi" },
  { id: "song11", name: "11 - Euphoria - Loreen" },
  { id: "song12", name: "12 - Bailar Pegados - Sergio Dalma" },
  { id: "song13", name: "13 - Baila El Chiki Chiki - Chikilicuatr " },
  { id: "song14", name: "14 - Slomo - Chanel" },
  { id: "song15", name: "15 - Ea Ea - Blanca Paloma" },
  { id: "song16", name: "16 - Diva - Dana Internacional" },
  { id: "song17", name: "17 - La La La - Massiel" },
  { id: "song18", name: "18 - Snap - Rosa Lin" },
  { id: "song19", name: "19 - Canta y sé feliz - Peret" },
  { id: "song20", name: "20 - Fuego - Eleni Foureira" },
  { id: "song21", name: "21 - Toy - Netta" },
  { id: "song22", name: "22 - Soldi - Mahmood" },
  { id: "song23", name: "23 - Heroes - Mans Zermelow" }
];

export default songs;